<template>
  <VApp>
    <VContainer
      fluid
    >
      <VDataTable
        :headers="headers"
        :items="items"
        :loading="loadingStatus"
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template
          slot="headers"
          slot-scope="props"
        >
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              class="text-xs-left"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <VIcon small>
                arrow_upward
              </VIcon>
            </th>
          </tr>
        </template>
        <VProgressLinear
          slot="progress"
          color="blue"
          indeterminate
        />
        <template
          slot="items"
          slot-scope="props"
        >
          <tr class="grey-text text-lighten-5">
            <td
              v-for="(value, key) in props.item"
              :key="key"
            >
              <div v-if="key==='numOfVoters'&&value > 0">
                <RouterLink
                  :to="{ name: 'pollingChoiceContacts',
                         params: { pollingEventChoiceId: choiceIds[props.item.code]},
                         query: { pollingEventChoiceName: props.item.name}}"
                >
                  {{ value }}
                </RouterLink>
              </div>
              <div v-else>
                {{ value }}
              </div>
            </td>
          </tr>
        </template>
      </VDataTable>
      <NetworkSnackBar />
    </VContainer>
  </VApp>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { LIST_POLLING_EVENT_DETAIL } from '@/backend/graphql/pollingGQL'
import { NetworkStatus } from 'apollo-client/core/networkStatus'
import NetworkSnackBar from '@/components/NetworkSnackBar'

export default {
  name: 'PollingEventChoicesPage',
  components: { NetworkSnackBar },
  data: function () {
    return {
      pagination: {
        sortBy: 'numOfVoters',
        descending: true
      },
      limit: 50,
      offset: 0,
      eventId: 0,
      headers: [],
      items: [],
      choiceIds: {}
    }
  },
  computed: {
    ...mapGetters({
      allPollingEvents: 'polling/getAllPollingEvents',
      pollingStatus: 'polling/getLoadingStatus',
      pollingStatusMessage: 'polling/getLoadingText',
      user: 'account/getUser'
    }),
    loadingStatus: {
      get: function () {
        return this.pollingStatus
      },
      set: function (val) {
        this.setLoadingStatus({ val })
      }
    },
    statusMessage: {
      get: function () {
        return this.pollingStatusMessage
      },
      set: function (message) {
        this.setStatusMessage({ message })
      }
    },
    alert () {
      return this.$store.state.alert
    }
  },
  watch: {
    allPollingEvents: function () {
      const choices = _.get(this.allPollingEvents, '[0].pollingEventChoice', [])
      if (choices.length > 0) {
        // setup headers
        this.headers = Object.keys(choices[0])
          .filter(item => {
            return item !== 'profilechoicetable' && item !== '__typename' && item !== 'id'
          }).map(item => {
            return {
              text: item,
              value: item,
              sortable: true
            }
          })
        this.headers.push({
          text: 'Num of Voters',
          value: 'numOfVoters',
          sortable: true
        })
        // setup items
        const self = this
        choices.map(item => {
          let obj = {}
          this.items.push(obj)
          this.headers.map((headerItem) => {
            const key = headerItem.value
            if (key === 'code') { self.choiceIds[item[key]] = _.get(item, 'id', 0) }
            if (key === 'numOfVoters') {
              obj[key] = _.get(item, 'profilechoicetable.length', 0)
            } else {
              obj[key] = item[key]
            }
          })
        }, self)
      }
    }
  },
  created () {
    this.eventId = this.$route.params.pollingEventId
  },
  beforeDestroy () {
    this.clearPollingEvents()
  },
  apollo: {
    choices: {
      query: LIST_POLLING_EVENT_DETAIL,
      variables () {
        return {
          limit: this.limit,
          offset: this.offset,
          eventId: this.eventId,
          choiceType: this.user.customer_type.includes('FAVORITE') ? 'FAVORITE' : 'LIKE'
        }
      },
      manual: true,
      result ({ data, loading, networkStatus }) {
        this.setQueryStatus(networkStatus)
        if (!loading && networkStatus !== NetworkStatus.error) {
          this.parseData(data)
        }
      },
      error (error) {
        this.loadingStatus = false
        this.$store.dispatch('alert/error', error.message)
      }
    }
  },
  methods: {
    ...mapActions({
      setStatusMessage: 'polling/setStatusMessage',
      setLoadingStatus: 'polling/setLoadingStatus',
      initPollingEvents: 'polling/init',
      appendPollingEvents: 'polling/next',
      clearPollingEvents: 'polling/clear'
    }),
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    setQueryStatus (networkStatus) {
      switch (networkStatus) {
        case NetworkStatus.loading:
          this.loadingStatus = true
          break
        case NetworkStatus.setVariables:
          this.loadingStatus = true
          break
        case NetworkStatus.ready:
          break
        case NetworkStatus.poll:
          break
        case NetworkStatus.error:
          this.loadingStatus = false
          break
        default:
          break
      }
    },
    getItems (data) { return data.listPollingEvents.results },
    getTotalItemsCount (data) { return data.listPollingEvents.totalCount },
    parseData (data) {
      if (this.allPollingEvents.length === 0) {
        this.initPollingEvents({
          newPollingEvents: this.getItems(data),
          totalCount: this.getTotalItemsCount(data),
          isFullArraySize: false
        })
      } else {
        this.appendPollingEvents({
          newPollingEvents: this.getItems(data),
          startIndex: this.getQueryVariables().offset
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
